var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "progress-indicator text-sm leading-6 text-center tracking-wider font-light uppercase"
  }, [_vm._v("\n\tStep " + _vm._s(_vm.step) + " of " + _vm._s(_vm.totalSteps) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };